export function formatVatRate(vatRate) {
  if (vatRate === null || vatRate === undefined || vatRate === "") {
    return "—";
  }
  const num = Number(vatRate);
  if (Number.isNaN(num)) {
    return "—";
  }
  return `${num}%`;
}

export function formatMoneyString(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const num = Number(String(value).replace(/\s/g, "").replace(",", "."));
  if (Number.isNaN(num)) {
    return `${value} ₽`;
  }
  return `${num.toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ₽`;
}
